import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PolicyText from '../components/PolicyText';

const Policies: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-black text-white py-24 px-6 border-t border-rock">
            <div className="max-w-3xl mx-auto">
                <Link to="/" className="inline-flex items-center gap-2 text-gray-500 hover:text-[#00d4ff] transition-colors mb-12 group">
                    <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
                    <span className="text-xs font-bold uppercase tracking-widest">Regresar</span>
                </Link>

                <div className="bg-[#1a1512] border border-rock p-8 md:p-14 shadow-2xl relative overflow-hidden">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-[#00d4ff]/5 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl mix-blend-screen pointer-events-none"></div>
                    <PolicyText />
                </div>
            </div>
        </div>
    );
};

export default Policies;
